<div class="flex flex-wrap summary" [formGroup]="dopplerForm">
  <!-- ==================== Left Section (Start) ==================== -->
  <div class="w-full mdw-1_2 p-5">
    <section class="dashboard-section" style="padding: 32px 24px; margin-bottom: 0">
      <header class="dashboard-section-header">
        <h2>Left Ovary</h2>
      </header>

      <div role="tabpanel" id="tab1">
        <div>Doppler</div>
        <div class="flex flex-wrap" style="padding: 0">
          <div class="w-full mdw-1_3 p-5">
            <div class="circle">
              <div class="circle-content">
                <div class="circle-content-title">PI</div>
                <div
                  class="l-flex-c t-field t-twin-fieldset"
                  style="background: #fff"
                  (dblclick)="reset('LPIStatus')"
                >
                  <label class="gestation-label">
                    <input
                      type="radio"
                      name="LPIStatus"
                      formControlName="LPIStatus"
                      [value]="0"
                      class="custom-check customInput"
                      aria-labelledby=""
                      checked=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> OK </span>
                  </label>

                  <label class="gestation-label customInput-check-true">
                    <input
                      type="radio"
                      name="LPIStatus"
                      formControlName="LPIStatus"
                      [value]="1"
                      class="custom-check customInput"
                      aria-labelledby=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> Not OK </span>
                  </label>
                </div>
              </div>
              <div class="sm-circle"><input formControlName="LPI" type="number" min="0" /></div>
            </div>
          </div>
          <div class="w-full mdw-1_3 p-5">
            <div class="circle">
              <div class="circle-content">
                <div class="circle-content-title">RI</div>
                <div
                  class="l-flex-c t-field t-twin-fieldset"
                  style="background: #fff"
                  (dblclick)="reset('LRIStatus')"
                >
                  <label class="gestation-label">
                    <input
                      type="radio"
                      name="LRIStatus"
                      formControlName="LRIStatus"
                      [value]="0"
                      class="custom-check customInput"
                      aria-labelledby=""
                      checked=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> OK </span>
                  </label>

                  <label class="gestation-label customInput-check-true">
                    <input
                      type="radio"
                      name="LRIStatus"
                      formControlName="LRIStatus"
                      [value]="1"
                      class="custom-check customInput"
                      aria-labelledby=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> Not OK </span>
                  </label>
                </div>
              </div>
              <div class="sm-circle"><input formControlName="LRI" type="number" min="0" /></div>
            </div>
          </div>
          <div class="w-full mdw-1_3 p-5">
            <div class="circle">
              <div class="circle-content">
                <div class="circle-content-title">S/D</div>
                <div
                  class="l-flex-c t-field t-twin-fieldset"
                  style="background: #fff"
                  (dblclick)="reset('LSDStatus')"
                >
                  <label class="gestation-label">
                    <input
                      type="radio"
                      name="LSDStatus"
                      formControlName="LSDStatus"
                      [value]="0"
                      class="custom-check customInput"
                      aria-labelledby=""
                      checked=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> OK </span>
                  </label>

                  <label class="gestation-label customInput-check-true">
                    <input
                      type="radio"
                      name="LSDStatus"
                      formControlName="LSDStatus"
                      [value]="1"
                      class="custom-check customInput"
                      aria-labelledby=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> Not OK </span>
                  </label>
                </div>
              </div>
              <div class="sm-circle"><input type="number" min="0" formControlName="LSD" /></div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="w100 summary-spreadHeight summary-diagnosis" style="padding-top: 16px">
        <section
          class="m-box"
          style="height: 100px; padding: 1.31em 0; box-shadow: none; border: 0; background: none"
        >
          <h2 style="margin-bottom: 16px; font-size: inherit; font-weight: 400">Comments</h2>
          <textarea class="scroller" formControlName="LDopplerComments"></textarea>

          <button
            class="t-btn-edit"
            *ngIf="!es.isClosed"
            (click)="
              atS.showAuto(
                dopplerForm.get('LDopplerComments'),
                'Left Doppler Comment',
                AutoTextUUIDs.LDopplerComments
              )
            "
          >
            Auto Text
          </button>
        </section>
      </div>
      <div role="tabpanel" id="tab2" hidden>Abnormal Left</div>
      <div role="tabpanel" id="tab3" hidden>Comment Left</div>
    </section>
  </div>
  <!-- ==================== Left Section (End) ==================== -->

  <!-- ==================== Right Section (Start) ==================== -->
  <div class="w-full mdw-1_2 p-5">
    <section class="dashboard-section" style="padding: 32px 24px; margin-bottom: 0">
      <header class="dashboard-section-header">
        <h2>Right Ovary</h2>
      </header>

      <div role="tabpanel" id="tab4">
        <div>Doppler</div>
        <div class="flex flex-wrap" style="padding: 0">
          <div class="w-full mdw-1_3 p-5">
            <div class="circle">
              <div class="circle-content">
                <div class="circle-content-title">PI</div>
                <div
                  class="l-flex-c t-field t-twin-fieldset"
                  style="background: #fff"
                  (dblclick)="reset('RPIStatus')"
                >
                  <label class="gestation-label">
                    <input
                      type="radio"
                      name="RPIStatus"
                      formControlName="RPIStatus"
                      [value]="0"
                      class="custom-check customInput"
                      aria-labelledby=""
                      checked=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> OK </span>
                  </label>

                  <label class="gestation-label customInput-check-true">
                    <input
                      type="radio"
                      name="RPIStatus"
                      formControlName="RPIStatus"
                      [value]="1"
                      class="custom-check customInput"
                      aria-labelledby=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> Not OK </span>
                  </label>
                </div>
              </div>
              <div class="sm-circle"><input type="number" min="0" formControlName="RPI" /></div>
            </div>
          </div>
          <div class="w-full mdw-1_3 p-5">
            <div class="circle">
              <div class="circle-content">
                <div class="circle-content-title">RI</div>
                <div
                  class="l-flex-c t-field t-twin-fieldset"
                  style="background: #fff"
                  (dblclick)="reset('RRIStatus')"
                >
                  <label class="gestation-label">
                    <input
                      type="radio"
                      name="RRIStatus"
                      formControlName="RRIStatus"
                      [value]="0"
                      class="custom-check customInput"
                      aria-labelledby=""
                      checked=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> OK </span>
                  </label>

                  <label class="gestation-label customInput-check-true">
                    <input
                      type="radio"
                      name="RRIStatus"
                      formControlName="RRIStatus"
                      [value]="1"
                      class="custom-check customInput"
                      aria-labelledby=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> Not OK </span>
                  </label>
                </div>
              </div>
              <div class="sm-circle"><input type="number" min="0" formControlName="RRI" /></div>
            </div>
          </div>
          <div class="w-full mdw-1_3 p-5">
            <div class="circle">
              <div class="circle-content">
                <div class="circle-content-title">S/D</div>
                <div
                  class="l-flex-c t-field t-twin-fieldset"
                  style="background: #fff"
                  (dblclick)="reset('RSDStatus')"
                >
                  <label class="gestation-label">
                    <input
                      type="radio"
                      name="RSDStatus"
                      formControlName="RSDStatus"
                      [value]="0"
                      class="custom-check customInput"
                      aria-labelledby=""
                      checked=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> OK </span>
                  </label>

                  <label class="gestation-label customInput-check-true">
                    <input
                      type="radio"
                      name="RSDStatus"
                      formControlName="RSDStatus"
                      [value]="1"
                      class="custom-check customInput"
                      aria-labelledby=""
                    />
                    <i class="customInput-display"></i>
                    <span class="gestation-title-text"> Not OK </span>
                  </label>
                </div>
              </div>
              <div class="sm-circle"><input type="number" min="0" formControlName="RSD" /></div>
            </div>
          </div>
        </div>

        <hr />
        <div class="w100 summary-spreadHeight summary-diagnosis">
          <section
            class="m-box"
            style="height: 100px; padding: 1.31em 0; box-shadow: none; border: 0; background: none"
          >
            <h2 style="margin-bottom: 16px; font-size: inherit; font-weight: 400">Comments</h2>

            <textarea class="scroller" formControlName="RDopplerComments"></textarea>
            <button
              class="t-btn-edit"
              *ngIf="!es.isClosed"
              (click)="
                atS.showAuto(
                  dopplerForm.get('RDopplerComments'),
                  'Right Doppler Comment',
                  AutoTextUUIDs.RDopplerComments
                )
              "
            >
              Auto Text
            </button>
          </section>
        </div>
      </div>
      <div role="tabpanel" id="tab5" hidden>Abnormal Left</div>
      <div role="tabpanel" id="tab6" hidden>Comment Left</div>
    </section>
  </div>
  <!-- ==================== Right Section (End) ==================== -->
</div>
